import { useEffect, useMemo, useState } from "react";
import { fetchSenderAgents } from "../api/communicationsApi";

/**
 * The part of `agents` this user may send a message as.
 *
 * Genneva Smarrelli, CRM-2026-00136 (2 Nov 2026): "Currently agents are able to
 * send sms & emails on behalf of other agents. Please make it only the specific
 * agent." Admins keep the whole office; an agent gets themselves, and a PA also
 * gets the agent they assist. The backend decides (and enforces it on save and
 * send); this only narrows the dropdown to match.
 *
 * Returns `{ options, ready }`. `options` is empty until the answer arrives, so
 * nobody is briefly offered the whole list. If the lookup fails it falls back
 * to just the logged-in user.
 */
export default function useSendableAgents(agents, currentUser) {
  const [scope, setScope] = useState(null);
  const myId = currentUser?.id;

  useEffect(() => {
    let live = true;
    Promise.resolve()
      .then(() => fetchSenderAgents())
      .then((res) => { if (live) setScope(res || { any: false, ids: myId ? [myId] : [] }); })
      .catch(() => { if (live) setScope({ any: false, ids: myId ? [myId] : [] }); });
    return () => { live = false; };
  }, [myId]);

  return useMemo(() => {
    if (!scope) return { options: [], ready: false };
    if (scope.any) return { options: agents, ready: true };
    const ids = new Set((scope.ids || []).map(String));
    return { options: agents.filter((a) => ids.has(String(a.id))), ready: true };
  }, [agents, scope]);
}
